module.exports = __webpack_public_path__ + "img/button-arrow.42ec3005.svg";